import { XMarkIcon } from '@heroicons/react/24/outline';
import React, { type FC } from 'react';

type ClearButtonProps = {
  handleClearInput: (any) => void;
  className?: string;
}

const ClearButton: FC<ClearButtonProps> = ({ handleClearInput, className }) => {

  return (
    <button type='reset'
      data-autotag='clear-input'
      onClick={handleClearInput}
      className={`rounded bg-indigo-600 ml-2 px-2 py-1.5 text-base font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${className}`}
    >
      <XMarkIcon className='w-5 h-5' />
    </button>
  );
};

export default ClearButton;
